<template>
  <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div
        v-if="readonly"
        style="
          text-align: center;
          font-weight: 800;
          width: 100%;
          background-color: wheat;
          color: red;
        "
      >
        READ ONLY
      </div>
      <h4>Team {{ team }}</h4>
      <!-- team select -->
      <!-- <v-select
        :items="['CAO', 'MET1', 'MET2', 'Other']"
        v-model="team"
        @change="team_select"
        label="Your Team"
      ></v-select> -->

      <v-text-field
        v-mask="'##/##/####'"
        maxlength="10"
        v-model="stat_data.stat_date"
        label="Date"
      ></v-text-field>
      <v-select
        v-model="stat_data.area"
        :items="area_items"
        label="AREA"
        required
        background-color="#ECEFF1"
      ></v-select>

      <h4>Standard</h4>

      <div>
        <!-- mobile drops -->
        <v-container class="pa-0 smonly" id="mobile_drops">
          <!-- deeds_hours -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="deeds_hours">Deeds Hours/Min</label>
            <select
              class="bcs_sel"
              v-model="stat_data.deeds_hours"
              id="deeds_hours"
            >
              <option
                v-for="(aint, index) in dhours15"
                :key="index"
                :value="aint"
              >
                {{ aint }}
              </option>
            </select>
          </div>
          <!-- group 1 -->
          <div>
            <!-- area_checks -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="area_checks">Area Checks</label>
              <select
                class="bcs_sel"
                v-model="stat_data.area_checks"
                id="area_checks"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- citizen_contacts -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="citizen_contacts"
                >Citizen Contacts</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.citizen_contacts"
                id="Citizen Contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- business_checks_contacts -->
            <div class="d-flex justify-start">
              <label for="business_checks_contacts" class="bcs_lbl"
                >Business Checks/Contacts</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.business_checks_contacts"
                id="business_checks_contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- group 2 -->
          <div>
            <!-- vehicle_checks -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl">Vehicle Checks </label>
              <select
                class="bcs_sel"
                v-model="stat_data.vehicle_checks"
                id="vehicle_checks"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- traffic_subject_stops -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="traffic_subject_stops"
                >Traffic Subject/Stops</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.traffic_subject_stops"
                id="traffic_subject_stops"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!--arrests-->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="arrests">Arrests</label>
              <select class="bcs_sel" v-model="stat_data.arrests" id="arrests">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- bomb_sniffs -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="bomb_sniffs">Bomb Sniffs</label>
              <select
                class="bcs_sel"
                v-model="stat_data.bomb_sniffs"
                id="bomb_sniffs"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- fcc_sniffs -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="fcc_sniffs">FCC Sniffs</label>
              <select
                class="bcs_sel"
                v-model="stat_data.fcc_sniffs"
                id="fcc_sniffs"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- missing_person_track -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="missing_person_track"
                >Missing Person Track</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.missing_person_track"
                id="missing_person_track"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- narcotic_sniffs -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="narcotic_sniffs"
                >Narcotic Sniffs</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.narcotic_sniffs"
                id="narcotic_sniffs"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- suspect_track -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="suspect_track">Suspect Track</label>
              <select
                class="bcs_sel"
                v-model="stat_data.suspect_track"
                id="suspect_track"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- save/reset buttons -->
          <v-row class="" v-if="!readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="save_stat"
              >
                Submit
              </v-btn>
              <v-btn
                v-if="edit_on == true"
                color="cmpbk"
                class="mr-4 white--text"
                @click="cancel_edit"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="edit_on == false"
                color="cmpbk"
                class="mr-4 white--text"
                @click="reset"
              >
                Reset Form
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="" v-if="readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                id="quit_view"
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="quit_view"
              >
                Quit View
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- deskstop -->

        <v-container class="pa-0 mdonly">
          <!-- row 1 -->
          <div class="mt-3 drop-row d-flex justify-center align-end">
            <!-- deeds_hours -->
            <div class="sel-int-col-25">
              <label for="deeds_hours">Deeds Hours/Min</label>
              <select v-model="stat_data.deeds_hours" id="deeds_hours">
                <option
                  v-for="(aint, index) in dhours15"
                  :key="index"
                  :value="aint"
                >
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- area_checks -->
            <div class="sel-int-col-25">
              <label for="area_checks" style="word-break: keep-all"
                >Area Checks</label
              >
              <select v-model="stat_data.area_checks" id="area_checks">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- citizen_contacts -->
            <div class="sel-int-col-25">
              <label for="citizen_contacts">Citizen_Contacts</label>
              <select
                v-model="stat_data.citizen_contacts"
                id="citizen_contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- business_checks_contacts -->
            <div class="sel-int-col-25">
              <label for="business_checks_contacts"
                >Business Checks/Contacts</label
              >
              <select
                v-model="stat_data.business_checks_contacts"
                id="business_checks_contacts"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 2 -->
          <div class="drop-row d-flex justify-center align-end">
            <!-- v checks -->
            <div class="sel-int-col-25">
              <label for="vehicle_checks">Vehicle Checks </label>
              <select v-model="stat_data.vehicle_checks" id="vehicle_checks">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <div class="sel-int-col-25">
              <label for="traffic_subject_stops">Traffic Subject / Stops</label>
              <select
                v-model="stat_data.traffic_subject_stops"
                id="traffic_subject_stops"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- aressts -->
            <div class="sel-int-col-25">
              <label for="arrests">Arrests</label>
              <select v-model="stat_data.arrests" id="arrests">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- bomb_sniffs -->
            <div class="sel-int-col-25">
              <label for="bomb_sniffs">Bomb Sniffs</label>
              <select v-model="stat_data.bomb_sniffs" id="bomb_sniffs">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 3 -->
          <div class="drop-row d-flex justify-center align-end">
            <!-- fcc_sniffs -->
            <div class="sel-int-col-25">
              <label for="fcc_sniffs"
                >FCC Sniffs &nbsp;&nbsp;&nbsp;&nbsp;</label
              >
              <select v-model="stat_data.fcc_sniffs" id="fcc_sniffs">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- missing_person_track -->
            <div class="sel-int-col-25">
              <label for="missing_person_track">Missing Person Track</label>
              <select
                v-model="stat_data.missing_person_track"
                id="missing_person_track"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- narcotic_sniffs -->
            <div class="sel-int-col-25">
              <label for="narcotic_sniffs">Narcotic Sniffs</label>
              <select v-model="stat_data.narcotic_sniffs" id="narcotic_sniffs">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- suspect_track -->
            <div class="sel-int-col-25">
              <label for="suspect_track">Suspect Track</label>
              <select v-model="stat_data.suspect_track" id="suspect_track">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="drop-row d-flex justify-center align-end mt-2"
            style="height: auto"
          >
            <div class="mt-4" style="width: 100%">
              <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
                >Narrative</label
              >
              <v-textarea
                class="mt-2"
                counter
                solo
                name="notes"
                v-model="stat_data.notes"
              ></v-textarea>
            </div>
          </div>

          <!-- save/reset buttons -->
          <v-row class="" v-if="!readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="save_stat"
              >
                Submit
              </v-btn>
              <v-btn
                v-if="edit_on == true"
                color="cmpbk"
                class="mr-4 white--text"
                @click="cancel_edit"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="edit_on == false"
                color="cmpbk"
                class="mr-4 white--text"
                @click="reset"
              >
                Reset Form
              </v-btn>
            </v-col>
          </v-row>
          <!-- save/reset buttons -->
          <v-row class="" v-if="readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                id="quit_view"
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="quit_view"
              >
                Quit View
              </v-btn>
            </v-col>
            <!-- <v-col cols="6">
          <v-btn color="cmpbk" class="mr-4 white--text" @click="reset">
            Reset Form
          </v-btn>
        </v-col> -->
          </v-row>
        </v-container>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
@media (min-width: 0px) {
  .thick {
    border: 1px solid rgb(3, 3, 82);
    margin-bottom: 3px;
  }
  .controlled:deep #substances_seized {
    text-align: right;
  }
  .smonly div.d-flex {
    margin-top: 10px;
  }
  .bcs_sel {
    width: 50%;
    // border: 1px solid black;
    background-color: whitesmoke;
    padding: 3px;
    margin-top: 3px;
  }
  .bcs_lbl {
    width: 50% !important;
    padding: 3px;
    margin-top: 6px;
  }
  .mdonly {
    display: none;
  }

  .drop-row {
    height: 95px;
  }
  .sel-int-col-25 {
    width: 25%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-33 {
    width: 33%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-50 {
    width: 50%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-100 select {
    width: 78%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
  // .sel-int-col-25 label {
  //   position: relative;
  //   top: 25px;
  // }
  .sel-int-col-25 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-50 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-33 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-33 input {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .stop-select {
    width: 95% !important;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    margin-left: 0 !important;
  }

  select {
    -webkit-appearance: listbox !important;
    appearance: listbox !important;
  }
  .v-input--selection-controls.v-input {
    height: 40px;
  }
}
/* 768 media q */
@media (min-width: 768px) {
  .mdonly {
    display: block;
  }
  .smonly {
    display: none;
  }
  .sel-int-col-100 select {
    width: 100%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;

    // position: relative;
    // top: 10px;
  }
  .stop-select {
    width: 95% !important;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    margin-left: 0 !important;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}
/* 1025 media q */
@media (min-width: 1025px) {
}
/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "add_editk9",
  mixins: [bus_common],
  components: {},
  props: [
    "addedit_update_now",
    "incoming_edit",
    "source",
    "scrollpos",
    "edit_on",
    "team",
    "readonly",
  ],
  //source will be 'srch' or 'rcnt'
  //scroll postion the name of the scroll postion
  data: () => ({
    show_addedit: true,
    address: "",
    loc: {},
    map_dialog_visible: false,
    stat_data: {
      rpd_stat_k9Id: 0,
      team: "",
      stat_date: "",
      area: "",
      other_area: "",

      deeds_hours: "0.00",
      area_checks: 0,
      citizen_contacts: 0,
      business_checks_contacts: 0,
      vehicle_checks: 0,
      traffic_subject_stops: 0,
      arrests: 0,

      bomb_sniffs: 0,
      fcc_sniffs: 0,
      missing_person_track: 0,
      narcotic_sniffs: 0,
      suspect_track: 0,

      notes: "",
    },
    stat_data_dev: {
      rpd_stat_k9Id: 0,
      team: "k9",
      stat_date: "4/30/2025",
      area: "DEEDS",
      other_area: "",
      deeds_hours: "0.00",
      area_checks: 1,
      citizen_contacts: 2,
      business_checks_contacts: 3,
      vehicle_checks: 4,
      traffic_subject_stops: 5,
      arrests: 6,
      bomb_sniffs: 7,
      fcc_sniffs: 8,
      missing_person_track: 9,
      narcotic_sniffs: 10,
      suspect_track: 11,
      notes: "My notes here.",
    },
    stat_data_new: {
      rpd_stat_k9Id: 0,
      team: "",
      stat_date: "",
      area: "DEEDS",
      other_area: "",

      deeds_hours: "0.00",
      area_checks: 0,
      citizen_contacts: 0,
      business_checks_contacts: 0,
      vehicle_checks: 0,
      traffic_subject_stops: 0,
      arrests: 0,

      bomb_sniffs: 0,
      fcc_sniffs: 0,
      missing_person_track: 0,
      narcotic_sniffs: 0,
      suspect_track: 0,

      notes: "",
    },
    update_ready: false,
    valid: true,
    name: "",
    locRules: [(v) => !!v || "Location is required"],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    types: ["Traffic", "Warrant", "Dispatch", "Complaint"],
    area_items: ["DEEDS", "Downtown Corridor", "City of Reno", "Other"],
    mission_types: [
      "DID Operation (ex: 4th street saturation Op/ Shopping Cart Op/ UC op)",
      "Area Check",
      "Ambassador Assist",
      "Business Check",
      "Call for Service",
      "Camp Cleanup",
      "City Walk",
      "Service Request",
      "Warrant Sweep",
      "Motel Inspection",
      "CPTED",
      "Other",
    ],
    checkbox: false,
  }),
  watch: {
    addedit_update_now: function (val) {
      if (this.update_ready) {
        this.update_ready = true;
        this.swall_it("Entry Status", "Entry Saved", "success");
        this.stat_data = this.mno(this.stat_data_new);
        this.$nextTick(() => {
          this.stat_data.stat_date = this.format_date_us(new Date());
        });

        console.log("Stat Date: " + this.stat_data.stat_date);
      }
    },
    incoming_edit: function (stat) {
      this.mrbreakpoint("incoming_editk9");
      this.stat_data = this.mno(stat);
      this.stat_data.stat_date = this.format_date_us(this.stat_data.stat_date);

      console.log("before: " + this.stat_data.deeds_hours);
      // this.stat_data.deeds_hours = parseFloat(
      //   this.stat_data.deeds_hour
      // ).toFixed(2);
      this.stat_data.deeds_hours = this.stat_data.deeds_hours
        .toFixed(2)
        .toString();

      console.log("after: " + this.stat_data.deeds_hours);
      console.log("area: " + this.stat_data.area);

      if (this.stat_data.area.indexOf("Other") > -1) {
        this.stat_data.area = "Other";
      }
    },
  },
  computed: {
    team_met() {
      if (this.edit_on) {
        if (this.stat_data.team == "MET1" || this.stat_data.team == "MET2") {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.team == "MET1" || this.team == "MET2") {
          return true;
        } else {
          return false;
        }
      }
    },
    dhours15() {
      let dhours15 = [];
      for (let hour = 0; hour <= 20; hour++) {
        for (let minutes = 0; minutes < 60; minutes += 15) {
          // let inc = `${hour.toString().padStart(2, "0")}:${minutes
          //   .toString()
          //   .padStart(2, "0")}`;
          let inc = (parseFloat(hour) + parseFloat(minutes / 100)).toFixed(2);
          dhours15.push(inc);
        }
      }
      return dhours15;
    },
    d10() {
      var d10 = [];
      for (let index = 0; index < 11; index++) {
        d10.push(index);
      }
      return d10;
    },
    d20() {
      var d20 = [];
      for (let index = 0; index < 21; index++) {
        d20.push(index);
      }
      return d20;
    },
    d30() {
      var d30 = [];
      for (let index = 0; index < 31; index++) {
        d30.push(index);
      }
      return d30;
    },
    d60() {
      var d60 = [];
      for (let index = 0; index < 61; index++) {
        d60.push(index);
      }
      return d60;
    },
    grants() {
      var grants = [];
      grants.push("None");
      for (let index = 0; index < this.lst_grants.length; index++) {
        const element = this.lst_grants[index];
        grants.push(element.grant_name);
      }
      return grants;
    },
    tsep_fromId() {
      return this.$store.state.edit_tsep_fromId;
    },
  },
  methods: {
    team_select() {
      let self = this;
      console.log("team_select save");
      if (this.team != "") {
        //save user team
        let formIn = {};
        formIn.email = this.$store.state.user.email;
        formIn.token = this.$store.state.user.token;
        formIn.team = this.team;
        formIn.apiname = "save_team_user";

        let self = this;
        this.$store
          .dispatch("anyapi", formIn)
          .then((data) => {
            self.team = data;
            self.panels = 0;
          })
          .catch((msg) => {
            self.dialog = false;
            this.show_loader(false);
            this.swall_it("Error save_team_user", msg, "error", null, null);
          });
      }
    },
    quit_view() {
      //this will also set read only to false putting us in the basic state
      this.$emit("cancel_editk9", this.stat_data);
    },
    save_stat() {
      var total = 0;
      let stat_data = this.mno(this.stat_data);
      //   this.mrbreakpoint("save_stat 1");
      if (this.stat_data.area == "" || this.stat_data.area == undefined) {
        this.swall_it(
          "Save Status ",
          "Please be sure you have selected an Area and a Mission before submitting. ",
          "warning",
          null,
          null
        );
        return true;
      }
      if (
        this.team == "" ||
        this.team == null ||
        this.stat_data.area == undefined
      ) {
        this.swall_it(
          "Save Status ",
          "Team not found. Change you team and try again. ",
          "warning",
          null,
          null
        );
        return true;
      }

      stat_data.team = this.team;
      stat_data.deeds_hours = parseFloat(stat_data.deeds_hours);

      stat_data.stat_date = this.format_date_sql(new Date(stat_data.stat_date));
      console.log(stat_data.stat_date);
      console.log("notes:" + stat_data.notes);

      this.update_ready = true;
      this.$emit("save_statk9", stat_data);
    },
    cancel_edit() {
      this.$emit("cancel_editk9", this.stat_data);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.init();
      this.show_loader(false);
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    init() {
      let self = this;
      console.log(this.show_addedit);
      setTimeout(() => {
        self.stat_data = self.mno(self.stat_data_new);
        this.stat_data.team = this.team;
        this.stat_data.stat_date = this.format_date_us(new Date());
      }, 500);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
